import React, { useState } from 'react'
import { Form, Card, Accordion, Button, InputGroup } from 'react-bootstrap'
import useSystemSettings from '../../../hooks/use-system-settings'
import useToasts from '../../../hooks/use-toasts'

const SystemSetting = ({
    item = {}
}) => {
    const [ value, setValue ] = useState(item.value)
    const {
        success: toastSuccess,
        error: toastError,
    } = useToasts({
        successMessage: 'Setting Saved!',
        errorMessage: 'Error saving setting.'
    })
    const { isUpdating, updateSystemSetting } = useSystemSettings({
        onSuccess: toastSuccess,
        onError: toastError,
    })
    const canSave = value !== item.value
    return (
        <Card>
            <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey={item.id}>
                    {item.name}
                </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={item.id}>
                <Card.Body>
                    <Form.Group>
                        <InputGroup>
                            <Form.Control type="text" value={value} onChange={e => setValue(e.target.value)} />
                            <InputGroup.Append>
                                <Button
                                    variant={canSave ? 'primary' : 'secondary'}
                                    disabled={!canSave}
                                    onClick={() => updateSystemSetting({ id: item.id, value })}
                                >
                                Save
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                        <Form.Text className="text-muted">
                            {item.description}
                        </Form.Text>
                    </Form.Group>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    )
}

export default SystemSetting